<template>
  <div class="service-support" v-if="$route.path === '/serviceSupport'">
    <div class="banner" :style="`background-image: url(${bannerUrl})`">
      <div class="banner-content">
        <div class="banner-content-info">
          {{ $t('serviceSupport.bannerTitle') }}
          <span></span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content-title">
        <div class="title">{{ $t('serviceSupport.title') }}</div>
        <span></span>
      </div>

      <div class="list">
        <div
          v-for="item in list"
          :key="item.id"
          class="list-item"
          @mouseenter="handleMouseEnter(item.id)"
          @mouseleave="handleMouseLeave"
        >
          <div
            :style="`background-image: url(${hoverId === item.id ? item.bg : item.greyBg})`"
            class="list-item-bg"
            :class="{ 'hover': hoverId === item.id }"
          >
            <div class="list-item-icon">
              <img :src="item.icon">
            </div>
            <span></span>
            <div class="list-item-name">{{ item.name }}</div>
            <div
              class="btn"
              :class="{ 'show': hoverId === item.id }"
              @click="detailClick(item.path)"
            >
              {{ $t('serviceSupport.learnMore') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-view v-else></router-view>
</template>

<script>
export default {
  data () {
    return {
      bannerUrl: require('@/assets/images/serviceSupport/banner.png'),
      hoverId: null,
    }
  },
  computed: {
    list () {
      return [
        { name: this.$t('serviceSupport.list.productInfo'), path: '/serviceSupport/productInfo', id: 1, greyBg: require('@/assets/images/serviceSupport/greyList1.png'), bg: require('@/assets/images/serviceSupport/list1.png'), icon: require('@/assets/images/serviceSupport/indexIcon1.png') },
        { name: this.$t('serviceSupport.list.development'), path: '/serviceSupport/development', id: 2, greyBg: require('@/assets/images/serviceSupport/greyList2.png'), bg: require('@/assets/images/serviceSupport/list2.png'), icon: require('@/assets/images/serviceSupport/indexIcon2.png') },
        { name: this.$t('serviceSupport.list.application'), path: '/serviceSupport/application', id: 3, greyBg: require('@/assets/images/serviceSupport/greyList3.png'), bg: require('@/assets/images/serviceSupport/list3.png'), icon: require('@/assets/images/serviceSupport/indexIcon3.png') },
        { name: this.$t('serviceSupport.list.simulation'), path: '/serviceSupport/simulation', id: 4, greyBg: require('@/assets/images/serviceSupport/greyList4.png'), bg: require('@/assets/images/serviceSupport/list4.png'), icon: require('@/assets/images/serviceSupport/indexIcon4.png') },
      ]
    }
  },
  methods: {
    detailClick (path) {
      this.$router.push(path)
      document.querySelector('body').scroll(0, 650)
    },
    handleMouseEnter (id) {
      this.hoverId = id
    },
    handleMouseLeave () {
      this.hoverId = null
    }
  },
}
</script>

<style scoped lang="scss">
.service-support {
  .banner {
    height: 405px;
    display: block;
    margin: 0 auto;
    background-size: 1920px 570px;
    padding-top: 165px;
    background-position: top center;
    background-repeat: no-repeat;
    .banner-content {
      width: 1200px;
      margin: 0 auto;
      .banner-content-info {
        width: 412px;
        height: 82px;
        border: 1px solid #fff;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(20px);
        font-weight: 600;
        font-size: 44px;
        color: #fff;
        padding: 70px 60px 80px;
        span {
          width: 80px;
          height: 4px;
          background: rgba(255, 255, 255, 1);
          display: block;
          margin-top: 16px;
        }
      }
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 56px;
    .list {
      display: flex;
      justify-content: center;
      align-items: center;

      .list-item {
        width: 300px;
        height: 600px;
        cursor: pointer;

        .list-item-bg {
          width: 100%;
          height: 100%;
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .list-item-icon {
            margin-bottom: 60px;
            transition: transform 0.3s ease;
          }

          .list-item-name {
            margin-top: 40px;
            font-size: 26px;
            color: #FFFFFF;
            font-weight: bold;
            transition: transform 0.3s ease;
            word-break: break-all;
            padding: 20px;
            font-size: 24px;
          }

          .btn {
            margin-top: 60px;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 20px;
            padding: 12px 24px;
            border: 1px solid rgba(255,255,255,0.5);
            border-radius: 4px 4px 4px 4px;
            display: none;
            opacity: 0;
            transition: all 0.3s ease;
          }

          span {
            width: 80px;
            height: 4px;
            background: #1C64D7;
            display: block;
            margin-top: 16px;
            transition: transform 0.3s ease;
          }

          &.hover {
            .list-item-icon,
            span,
            .list-item-name {
              transform: translateY(-20px);
            }
            .btn {
              display: block;
              opacity: 1;
            }
          }
        }
      }
    }
    .content-title {
      padding-top: 100px;
      padding-bottom: 60px;
      .title {
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
      }
      span {
        display: block;
        margin-top: 16px;
        width: 80px;
        height: 4px;
        background: rgba(28, 100, 215, 1);
      }
    }
  }
}
</style>
